<template>
  <footer class="app-footer">
    <span class="footer-text">PandaCode © {{ new Date().getFullYear() }}</span>
  </footer>
</template>
<script>
export default {
  name: "PieComponent",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@500&display=swap');

.app-footer {
  --bg: #0E0E10;
  --card-border: #26262A;
  --text-tertiary: #5C5C62;

  background: var(--bg);
  border-top: 1px solid var(--card-border);
  padding: 14px 24px;
  display: flex;
  justify-content: flex-end;
}

.footer-text {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10.5px;
  letter-spacing: 0.03em;
  color: var(--text-tertiary);
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/PieComponent.vue